import { Accordion } from '@shared/components/ui/accordion/accordion';
import { PlanillaCultivo } from './planilla-cultivo';
import { Component, inject, OnInit } from '@angular/core';
import { etiquetaVaca } from '@shared/utils/etiqueta-vaca';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
// `CheckboxComponent` salió del import: su único uso era el clivaje, comentado
// por el issue #8. Si el cliente lo pide de vuelta hay que reponerlo acá y
// descomentar el bloque del template.
import { AppFormComponent, DataTable, SelectOption, TableCellDirective, TableColumn } from '@shared/components/ui/list-components';
import { ButtonComponent } from '../../../../../../shared/components/ui/button/button.component';
import { Card } from '../../../../../../shared/components/common/card/card';
import { EditionButtons } from '../../../../../../shared/components/ui/edition-buttons/edition-buttons';
import { InputFieldComponent } from '../../../../../../shared/components/form/input/input-field.component';
import { LabelComponent } from '../../../../../../shared/components/form/label/label.component';
import { PageHeaderComponent } from '../../../../../../shared/components/common/page-header/page-header.component';
import { SelectFieldComponent } from '@shared/components/form/select/select-field.component';
import { Spinner } from '../../../../../../shared/components/ui/spinner/spinner';
// import { TextareaFieldComponent } from '../../../../../../shared/components/form/textarea/textarea-field.component'; // sin observación en el template
import { DeleteTrigger } from '../../../../../../shared/components/ui/delete-trigger/delete-trigger';
import { ErrorService } from '../../../../../../shared/services/error.service';
import { FormStatusService } from '../../../../../../shared/services/form-status.service';
import { SnackbarService } from '@shared/services/snackbar.service';
import { hoyLocal, sumarDiasLocal } from '@shared/utils/fecha-local';
import { Agendamiento } from '../../../agendamientos/opu/agendamientos.interface';
import { AgendamientosService } from '../../../agendamientos/opu/agendamientos.service';
import { Solucion } from '../../../parametricos/soluciones/soluciones.interface';
import { etiquetaSolucion } from '@shared/utils/etiqueta-solucion';
import { CultivoEmbrionario, CultivoEmbrionarioControl, CultivoEmbrionarioControlPayload, EstadioEmbrionario, TecnicaCongelamiento } from '../cultivos.interface';
import { CultivosService } from '../cultivos.service';
import { OpsColor, OpsPunto } from '../../../stock/embriones/embriones.interface';
import {
  CampoControlCultivo,
  DIA_CLIVAJE,
  MATRIZ_CONTROL_CULTIVO,
  TurnoControlCultivo,
  CAMPOS_CONTROL_CULTIVO,
  estadoCampoControl,
  etapaDeDia,
  etiquetaDia,
  turnosDeDia,
} from '../cultivos.matriz';
import { AuthenticationService } from '@core/auth/authentication.service';

@Component({
  selector: 'app-detalle-cultivo',
  imports: [
    Accordion,
    PlanillaCultivo,
    AppFormComponent,
    ButtonComponent,
    Card,
    // CheckboxComponent, // issue #8: sin selector de clivaje
    // DataTable, // historial de controles oculto
    // DeleteTrigger, // historial de controles oculto
    EditionButtons,
    InputFieldComponent,
    LabelComponent,
    PageHeaderComponent,
    ReactiveFormsModule,
    SelectFieldComponent,
    Spinner,
    // TableCellDirective, // historial de controles oculto
    // TextareaFieldComponent, // sin observación en el template
  ],
  templateUrl: './detalle-cultivo.html'
})
export class DetalleCultivo implements OnInit {
  /** La vaca se identifica por su RP, como en la caravana. */
  readonly etiquetaVaca = etiquetaVaca;

  idAgendamiento = 0;
  idCultivo = 0;
  agendamiento!: Agendamiento;
  cultivo!: CultivoEmbrionario;
  cultivoForm!: FormGroup;
  /** Issue #7 (2026-09-15): catálogo de Soluciones, reutilizado como "medio". */
  soluciones: Solucion[] = [];
  controlForm!: FormGroup;
  loading = false;
  loadFailed = false;
  editable = true;
  updating = false;
  readonly auth = inject(AuthenticationService);
  canEdit = false;
  get canCreate(): boolean {
    return !!this.agendamiento && ['G', 'F'].includes(this.agendamiento.estado_agendamiento.codigo)
      && this.auth.hasPermission('pive.proceso', 'create');
  }
  get canDelete(): boolean {
    return !!this.agendamiento && ['G', 'F'].includes(this.agendamiento.estado_agendamiento.codigo)
      && this.auth.hasPermission('pive.proceso', 'delete');
  }
  changed = false;
  processingControl = false;
  editingControlId: number | null = null;
  deletingControl = false;
  deletingControlId: number | null = null;

  estadios: EstadioEmbrionario[] = [];
  tecnicasCongelamiento: TecnicaCongelamiento[] = [];
  // Issue #20 (2026-09-15): el raque pasó a texto libre; el combo del
  // paramétrico ya no se carga.
  // raques: ParamConCodigo[] = [];
  opsPuntos: OpsPunto[] = [];
  opsColores: OpsColor[] = [];

  controlColumns: TableColumn[] = [
    { key: 'dia', header: 'Día' },
    { key: 'turno', header: 'Turno' },
    { key: 'fecha_control', header: 'Fecha' },
    { key: 'estadio', header: 'Estadio' },
    { key: 'grado', header: 'Grado' },
    { key: 'prevision', header: 'Previsión' },
    { key: 'cantidad', header: 'Cantidad' },
    { key: 'clivaje', header: 'Clivaje' },
    { key: 'acciones', header: 'Acciones' },
  ];

  private fB = inject(FormBuilder);
  private fS = inject(FormStatusService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private cultivosService = inject(CultivosService);
  private agendamientosService = inject(AgendamientosService);
  private errorService = inject(ErrorService);
  private snackbarService = inject(SnackbarService);

  get estadiosOptions(): SelectOption[] {
    return this.estadios.map(e => ({ value: e.id, label: `${e.codigo} - ${e.nombre}` }));
  }

  get solucionesOptions(): SelectOption[] {
    return this.soluciones.map(s => ({ value: s.id, label: etiquetaSolucion(s) }));
  }

  // get raquesOptions(): SelectOption[] {
  //   return this.raques.map(r => ({ value: r.id, label: `${r.codigo} - ${r.nombre}` }));
  // }

  get opsPuntosOptions(): SelectOption[] {
    return this.opsPuntos.map(p => ({ value: p.id, label: p.codigo }));
  }

  get opsColoresOptions(): SelectOption[] {
    return this.opsColores.map(c => ({ value: c.id, label: c.nombre }));
  }

  get editingControl(): CultivoEmbrionarioControl | undefined {
    return this.cultivo?.controles.find(c => c.id === this.editingControlId);
  }

  // --- Matriz por día -----------------------------------------------------
  // El día del ciclo decide qué se registra. La fuente de verdad es
  // `cultivos.matriz.ts`, espejo de MatrizControlCultivo en el backend.

  get diaOptions(): SelectOption[] {
    return MATRIZ_CONTROL_CULTIVO.map(d => ({ value: d.dia, label: etiquetaDia(d.dia) }));
  }

  get diaSeleccionado(): number {
    return Number(this.controlForm?.get('dia')?.value) || 0;
  }

  get etapaDelDia(): string | null {
    return etapaDeDia(this.diaSeleccionado);
  }

  get turnoOptions(): SelectOption[] {
    return turnosDeDia(this.diaSeleccionado).map(t => ({ value: t, label: t }));
  }

  get mostrarTurno(): boolean {
    return turnosDeDia(this.diaSeleccionado).length > 0;
  }

  mostrarCampo(campo: CampoControlCultivo): boolean {
    return estadoCampoControl(this.diaSeleccionado, campo) !== 'prohibido';
  }

  // El día 8 es descarte: cierra el ciclo y ya no admite salida.
  get cultivoCerrado(): boolean {
    return this.cultivo?.cerrado === true;
  }

  ngOnInit(): void {
    this.idAgendamiento = Number(this.route.snapshot.paramMap.get('idAgendamiento'));
    this.idCultivo = Number(this.route.snapshot.paramMap.get('idCultivo'));

    if (!this.isValidId(this.idAgendamiento) || !this.isValidId(this.idCultivo)) {
      this.loadFailed = true;
      this.snackbarService.showSnackBar('No se pudo cargar el cultivo solicitado');
      return;
    }

    this.makeForms();
    this.getData();
  }

  private makeForms(): void {
    this.cultivoForm = this.fB.group({
      fecha_inicio: [{ value: '', disabled: this.editable }, Validators.required],
      // Opcional: el laboratorio puede no haber registrado el medio.
      param_solucion_id: [{ value: '', disabled: this.editable }],
      observacion: [{ value: '', disabled: this.editable }],
    });

    this.controlForm = this.fB.group({
      dia: [DIA_CLIVAJE, Validators.required],
      turno: [{ value: null as TurnoControlCultivo | null, disabled: true }],
      fecha_control: [this.hoyLocal(), Validators.required],
      param_estadio_embrionario_id: [''],
      grado: [''],
      prevision: [''],
      cantidad: [''],
      // Issue #8 (2026-09-15): sin checkbox, un control nuevo no mide clivaje.
      // Arranca en null (no medido) en vez de false (medido y negativo).
      clivaje: [null as boolean | null],
      observacion: [''],
    });

    this.controlForm.get('dia')?.valueChanges.subscribe(dia => this.onDiaChange(Number(dia)));
    this.aplicarMatriz(DIA_CLIVAJE);

  }

  private onDiaChange(dia: number): void {
    this.aplicarMatriz(dia);
    this.sincronizarTurno(dia);
    this.sincronizarFecha(dia);
  }

  /**
   * Habilita, exige o limpia cada campo según lo que la matriz define para el
   * día. Los campos prohibidos se ponen en null para que no viajen al backend
   * arrastrados de un día anterior.
   */
  private aplicarMatriz(dia: number): void {
    const turno = this.controlForm.get('turno');
    const turnos = turnosDeDia(dia);

    if (turnos.length === 0) {
      turno?.setValue(null, { emitEvent: false });
      turno?.clearValidators();
      turno?.disable({ emitEvent: false });
    } else {
      turno?.enable({ emitEvent: false });
      turno?.setValidators([Validators.required]);
    }

    turno?.updateValueAndValidity({ emitEvent: false });

    for (const campo of CAMPOS_CONTROL_CULTIVO) {
      const control = this.controlForm.get(campo);

      if (!control) {
        continue;
      }

      switch (estadoCampoControl(dia, campo)) {
        case 'obligatorio':
          control.setValidators([Validators.required]);
          break;
        case 'opcional':
          control.clearValidators();
          break;
        default:
          control.clearValidators();
          control.setValue(campo === 'clivaje' ? null : '', { emitEvent: false });
      }

      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  /** Preselecciona el primer turno todavía libre del día (AM7 antes que PM7). */
  private sincronizarTurno(dia: number): void {
    const turnos = turnosDeDia(dia);

    if (turnos.length === 0) {
      return;
    }

    this.controlForm.get('turno')?.setValue(this.primerTurnoLibre(dia), { emitEvent: false });
  }

  /** Pedido del cliente: la fecha del control se calcula, no se tipea. */
  private sincronizarFecha(dia: number): void {
    this.controlForm.get('fecha_control')?.setValue(this.fechaParaDia(dia), { emitEvent: false });
  }

  private primerTurnoLibre(dia: number): TurnoControlCultivo | null {
    const turnos = turnosDeDia(dia);

    if (turnos.length === 0) {
      return null;
    }

    const registrados = this.controlesRegistrados();

    return turnos.find(t => !registrados.has(this.claveControl(dia, t))) ?? turnos[0];
  }

  /**
   * Arranca en el día de clivaje, que es donde el laboratorio empieza a cargar,
   * y avanza al primer hueco. Si de ahí en adelante está todo cubierto, recorre
   * la matriz completa por si falta algún día temprano.
   */
  private proximoDiaSugerido(): number {
    const registrados = this.controlesRegistrados();
    const desdeClivaje = MATRIZ_CONTROL_CULTIVO.filter(d => d.dia >= DIA_CLIVAJE);

    for (const config of [...desdeClivaje, ...MATRIZ_CONTROL_CULTIVO]) {
      const libre = config.turnos.length === 0
        ? !registrados.has(this.claveControl(config.dia, null))
        : config.turnos.some(t => !registrados.has(this.claveControl(config.dia, t)));

      if (libre) {
        return config.dia;
      }
    }

    return DIA_CLIVAJE;
  }

  private controlesRegistrados(): Set<string> {
    return new Set(
      (this.cultivo?.controles ?? [])
        .filter(c => c.id !== this.editingControlId)
        .map(c => this.claveControl(c.dia, c.turno))
    );
  }

  private claveControl(dia: number, turno: TurnoControlCultivo | null): string {
    return `${dia}-${turno ?? ''}`;
  }

  private hoyLocal(): string {
    return hoyLocal();
  }

  /** `dia` son días post-FIV, y `fecha_inicio` del cultivo es el día de la FIV. */
  private fechaParaDia(dia: number): string {
    return sumarDiasLocal(this.cultivo?.fecha_inicio, dia) ?? hoyLocal();
  }

  private getData(): void {
    this.loading = true;
    this.loadFailed = false;

    const agendamiento$ = this.agendamientosService.show(this.idAgendamiento);
    const cultivo$ = this.cultivosService.show(this.idAgendamiento, this.idCultivo);
    const estadios$ = this.cultivosService.comboEstadios(this.idAgendamiento);
    const tecnicasCongelamiento$ = this.cultivosService.comboTecnicasCongelamiento(this.idAgendamiento);
    const opsPuntos$ = this.cultivosService.comboOpsPuntos();
    const opsColores$ = this.cultivosService.comboOpsColores();
    // Mismo combo que usa el agendamiento para equipos y materiales.
    const soluciones$ = this.agendamientosService.comboSoluciones();

    forkJoin([agendamiento$, cultivo$, estadios$, tecnicasCongelamiento$, opsPuntos$, opsColores$, soluciones$]).subscribe({
      next: (response) => {
        if (response[0].status) {
          this.agendamiento = response[0].data;
          this.canEdit = this.auth.hasPermission('pive.proceso', 'edit') && ['G', 'F'].includes(this.agendamiento.estado_agendamiento.codigo);
        }

        if (response[1].status) {
          this.cultivo = response[1].data;
          this.cultivoForm.patchValue({
            fecha_inicio: response[1].data.fecha_inicio,
            param_solucion_id: response[1].data.param_solucion_id ?? '',
            observacion: response[1].data.observacion,
          });
          // Recién con el cultivo cargado se puede sugerir día y fecha reales.
          this.resetControlForm();
        }

        if (response[2].status) {
          this.estadios = response[2].data;
        }

        if (response[3].status) {
          this.tecnicasCongelamiento = response[3].data;
        }

        if (response[4].status) {
          this.opsPuntos = response[4].data;
        }

        if (response[5].status) {
          this.opsColores = response[5].data;
        }

        if (response[6].status) {
          this.soluciones = response[6].data;
        }
      },
      error: (error) => {
        this.loadFailed = true;
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  updateCultivo(): void {
    this.updating = true;
    const valores = this.cultivoForm.getRawValue();
    const payload = {
      ...valores,
      // `app-select` emite string: sin el Number el backend recibe "3" y el
      // '' de "sin medio" tiene que viajar como null, no como cadena vacía.
      param_solucion_id: valores.param_solucion_id ? Number(valores.param_solucion_id) : null,
    };

    this.cultivosService.update(this.idAgendamiento, this.idCultivo, payload).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Cultivo actualizado correctamente');
          this.changed = true;
          this.refreshCultivo();
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.updating = false;
    });
  }

  saveControl(): void {
    if (!(this.editingControlId ? this.canEdit : this.canCreate)) {
      return;
    }

    this.processingControl = true;
    const payload = this.normalizeControlPayload();
    const request$ = this.editingControlId
      ? this.cultivosService.updateControl(this.idAgendamiento, this.idCultivo, this.editingControlId, payload)
      : this.cultivosService.storeControl(this.idAgendamiento, this.idCultivo, payload);

    request$.subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar(this.editingControlId ? 'Control actualizado correctamente' : 'Control creado correctamente');
          this.changed = true;
          this.resetControlForm();
          this.reloadCultivo();
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.processingControl = false;
    });
  }

  editControl(control: CultivoEmbrionarioControl): void {
    if (!this.canEdit) {
      return;
    }

    this.editingControlId = control.id;

    // `emitEvent: false`: el listener de `dia` recalcula turno y fecha, y acá se
    // quiere el control tal como está guardado, no el sugerido.
    this.controlForm.patchValue({
      dia: control.dia,
      turno: control.turno,
      fecha_control: control.fecha_control,
      param_estadio_embrionario_id: control.param_estadio_embrionario_id ?? '',
      grado: control.grado ?? '',
      prevision: control.prevision ?? '',
      cantidad: control.cantidad ?? '',
      clivaje: control.clivaje ?? null,
      observacion: control.observacion ?? '',
    }, { emitEvent: false });

    this.aplicarMatriz(control.dia);
    this.controlForm.get('turno')?.setValue(control.turno, { emitEvent: false });
  }

  deleteControl(controlId: number, index: number): void {
    if (!this.canDelete) {
      return;
    }

    this.deletingControl = true;
    this.deletingControlId = index;

    this.cultivosService.destroyControl(this.idAgendamiento, this.idCultivo, controlId).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Control eliminado correctamente');
          this.changed = true;
          this.resetControlForm();
          this.reloadCultivo();
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.deletingControl = false;
      this.deletingControlId = null;
    });
  }

  resetControlForm(): void {
    this.editingControlId = null;

    const dia = this.proximoDiaSugerido();

    this.controlForm.reset({
      dia,
      turno: this.primerTurnoLibre(dia),
      fecha_control: this.fechaParaDia(dia),
      param_estadio_embrionario_id: '',
      grado: '',
      prevision: '',
      cantidad: '',
      clivaje: null,
      observacion: '',
    }, { emitEvent: false });

    this.aplicarMatriz(dia);
    this.controlForm.get('turno')?.setValue(this.primerTurnoLibre(dia), { emitEvent: false });
  }

  editableSwitcher(): void {
    if (!this.canEdit) {
      return;
    }

    this.fS.changeStatus(this.cultivoForm, this.editable);
    this.editable = !this.editable;
  }

  refreshCultivo(): void {
    if (!this.editable) {
      this.editableSwitcher();
    }

    this.reloadCultivo();
  }

  close(): void {
    if (this.isValidId(this.idAgendamiento)) {
      this.router.navigate(['/pive', this.idAgendamiento], {
        queryParams: { tab: 'cultivo' }
      });
      return;
    }

    this.router.navigate(['/pive']);
  }

  private isValidId(value: number): boolean {
    return Number.isInteger(value) && value > 0;
  }

  reloadCultivo(): void {
    this.cultivosService.show(this.idAgendamiento, this.idCultivo).subscribe({
      next: (response) => {
        if (response.status) {
          this.cultivo = response.data;
          this.cultivoForm.patchValue({
            fecha_inicio: response.data.fecha_inicio,
            param_solucion_id: response.data.param_solucion_id ?? '',
            observacion: response.data.observacion,
          });
          if (!this.editingControlId) {
            this.resetControlForm();
          }
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    });
  }

  private normalizeControlPayload(): CultivoEmbrionarioControlPayload {
    const raw = this.controlForm.getRawValue();
    const dia = Number(raw.dia);

    // Los campos que la matriz no habilita para el día viajan en null: el
    // backend los rechaza si llegan con valor.
    const campo = (nombre: CampoControlCultivo, valor: unknown) =>
      this.mostrarCampo(nombre) ? valor : null;

    const numero = (valor: unknown) => (valor === '' || valor === null || valor === undefined ? null : Number(valor));

    return {
      dia,
      turno: this.mostrarTurno ? (raw.turno as TurnoControlCultivo | null) : null,
      fecha_control: raw.fecha_control,
      param_estadio_embrionario_id: campo('param_estadio_embrionario_id', raw.param_estadio_embrionario_id || null) as number | null,
      grado: campo('grado', numero(raw.grado)) as number | null,
      prevision: campo('prevision', numero(raw.prevision)) as number | null,
      cantidad: campo('cantidad', numero(raw.cantidad)) as number | null,
      // El checkbox ya no existe (issue #8), pero el valor sigue viajando: así
      // una edición de un control viejo no borra el clivaje que ya tenía.
      clivaje: campo('clivaje', raw.clivaje ?? null) as boolean | null,
      observacion: raw.observacion || null,
    };
  }
}
